import { FilterModel } from 'src/app/shared/components/listing-page/services/listing-page-model/listing-page-model.types';
import { TranslateRegistry } from 'src/app/services/translate/translate.registry';
import { DeviceListingFieldName, DeviceType } from 'src/app/pages/equipment/devices/components/devices.models';

const createDeviceTypeFilterItems = (): FilterModel['items'] => [
  { text: TranslateRegistry.get.FILTER.DEVICE_TYPE.DCU, value: DeviceType.DCU },
  { text: TranslateRegistry.get.FILTER.DEVICE_TYPE.EXACTAGUARD, value: DeviceType.ExactaGuard },
  { text: TranslateRegistry.get.FILTER.DEVICE_TYPE.METER, value: DeviceType.Meter },
  { text: TranslateRegistry.get.FILTER.DEVICE_TYPE.MTU, value: DeviceType.MTU },
  { text: TranslateRegistry.get.FILTER.DEVICE_TYPE.RDD, value: DeviceType.RDD },
  { text: TranslateRegistry.get.FILTER.DEVICE_TYPE.RMD, value: DeviceType.RMDSensor },
  { text: TranslateRegistry.get.FILTER.DEVICE_TYPE.SBS, value: DeviceType.BaseStation }
];

export const HISTORY_LOG_DEVICE_TYPE: FilterModel = {
  selected: createDeviceTypeFilterItems(),
  filterType: DeviceListingFieldName.DeviceType,
  isMultiselect: true,
  items: createDeviceTypeFilterItems(),
  title: TranslateRegistry.get.FILTER.TITLE.DEVICE_TYPE,
  width: 134
};
